import { InjectionToken } from '@angular/core';

/**
 * Header Accept-Language injetado no SSR (ver server.ts). No browser é '' por
 * padrão (ver app.config.ts) — lá usamos navigator.language/localStorage.
 */
export const ACCEPT_LANGUAGE = new InjectionToken<string>('ACCEPT_LANGUAGE', {
  factory: () => '',
});
